/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface AccountResetToStripeTrialSuperAdmin
 */
export interface AccountResetToStripeTrialSuperAdmin {
    /**
     * Target account to reset.
     * @type {string}
     * @memberof AccountResetToStripeTrialSuperAdmin
     */
    accountId: string;
    /**
     * Stripe-billed plan id to put the account on (must be in PlanStore.AVAILABLE_PLAN_NAMES).
     * @type {string}
     * @memberof AccountResetToStripeTrialSuperAdmin
     */
    planId: string;
}

export function AccountResetToStripeTrialSuperAdminFromJSON(json: any): AccountResetToStripeTrialSuperAdmin {
    return {
        'accountId': json['accountId'],
        'planId': json['planId'],
    };
}

export function AccountResetToStripeTrialSuperAdminToJSON(value?: AccountResetToStripeTrialSuperAdmin): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'accountId': value.accountId,
        'planId': value.planId,
    };
}


